<template>
  <div :key="MailInvoiceKey" :class="isResendMail ? '' : 'm-4'" class="clearfix ">
    <div v-if="isResendMail">
      <h4 class="mb-3 font-size-14 font-weight-bold text-primary text-uppercase">
        {{$t("reporting.supplier.tabMailInvoice.manualSettingCardTitle")}}
      </h4>
    </div>
    <div v-else>
      <h4 class="card-title mb-4 font-size-18 font-weight-bold text-dark">
        {{$t("reporting.supplier.tabMailInvoice.settingCardTitle")}}
      </h4>
    </div>

    <div>
      <div v-if=" company == null || company == 'PHARMA'" class="row mb-2">
        <span :class="isResendMail ? 'col-12 ' : 'col-md-12 col-12' " class="mail-label w-100">
          {{ $t("reporting.supplier.tabMailInvoice.pharma") }}
        </span>

        <div  :class="isResendMail ? 'col-12 text-left mt-3 ' : 'col-md-12 col-12 text-left' " class="w-100 mt-3">
          <b-button-group>
            <b-button
              v-for="opt in options"
              :key="'pharma-' + opt.value"
              :class="isSelected('pharma', opt.key) ? 'btn-select-no-hover' : 'outline-btn-select-no-hover'"
              size="sm"
              class="px-3 mx-1 "
              @click="toggleSelect('pharma', opt.key)"
            >
              {{ $t(opt.label) }}
            </b-button>
          </b-button-group>
        </div>

      </div>

      <div  v-if=" company == null || company == 'PARA'" class="row mt-4">
        <span  :class="isResendMail ? 'col-12 mt-3' : 'col-md-12 col-12' " class="mail-label w-100">
          {{ $t("reporting.supplier.tabMailInvoice.para") }}
        </span>

        <div  :class="isResendMail ? 'col-12 text-left mt-2' : 'col-md-12 col-12 text-left' " class="w-100 mt-3">
          <b-button-group>
            <b-button
              v-for="opt in options"
              :key="'para-' + opt.value"
              :class="isSelected('para', opt.key) ? 'btn-select-no-hover' : 'outline-btn-select-no-hover'"
              size="sm"
              class="px-3 mx-1 btn-no-hover"
              @click="toggleSelect('para', opt.key)"
            >
              {{ $t(opt.label) }}
            </b-button>
          </b-button-group>
        </div>

      </div>


      <div class="text-right mt-3 " v-if="isResendMail">
          <b-button variant="primary" class="text-uppercase font-weight-bold font-size-14" size="sm" @click="resendAllMail">
              ré-envoyer
          </b-button>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "MailInvoiceSettingCard",

  props: {
    invoiceMailSettings: {
      type: Array,
      required: true,
    },
    isResendMail: {
      type: Boolean,
      default: false,
    },
    company: {
      type: String,
      default: null,
    },
  },

  watch:{
    invoiceMailSettings: {
      handler() {
        this.MailInvoiceKey ++
      },
      deep: true
    }
  },  

  data() {
    return {
      MailInvoiceKey: 0,
      options: [
        { value: 1, label: "reporting.supplier.tabMailInvoice.btnReleve", key: "fact" },
        { value: 2, label: process.env.VUE_APP_CLIENT_NAME === "cab" ? "reporting.supplier.tabMailInvoice.btnElectronicCab" : "reporting.supplier.tabMailInvoice.btnElectronic", key: "fe" },
        { value: 3, label: "reporting.supplier.tabMailInvoice.btnTnn", key: "fttn" }
      ],
    };
  },

  methods: {
    isSelected(company, key) {
      const setting = this.invoiceMailSettings.find(
        s => s.company === company && s.invoiceType.endsWith(key)
      );
      return setting ? setting.value : false;
    },

    toggleSelect(company, key) {
      const setting = this.invoiceMailSettings.find(
        s => s.company === company && s.invoiceType.endsWith(key)
      );
      if (setting) {
        setting.value = !setting.value;
      } else {
        this.invoiceMailSettings.push({
          company: company,
          invoiceType: `invoice.${company}.${key}`,
          value: true
        });
      }

      if(!this.isResendMail){
        this.$emit('update:invoiceMailSettings', this.invoiceMailSettings);
      }

    },

    resendAllMail() {
      this.$emit('resendMail' , this.invoiceMailSettings)
    }
  },
};
</script>

<style scoped>

.mail-label {
  width: 120px;
  font-weight: 600;
}

.btn-select-no-hover {
  background-color: #96c11f !important;  
  border-color: #96c11f !important;
  color: #fff !important;          
  box-shadow: none !important;
  border-radius: 0px;
  font-weight: bold;
}


.outline-btn-select-no-hover {
  background-color: transparent !important; 
  border-color: #96c11f !important;           
  color: #939090 !important;                 
  box-shadow: none !important;
  border-radius: 0px;
  font-weight: bold;
}



</style>
